import { ECOREBATES_ENDPOINT_URL } from './constants';

export const getEcoRebatesUrl = ({
  consumerType,
  filterData: { appliedFilters, searchedItem },
  pageNumber,
  pageSize,
  zipCode,
}) => {
  let rebatesUrl = ECOREBATES_ENDPOINT_URL
    + `?filter_rebate_consumer_type=${consumerType}`
    + `&zip=${zipCode}`
    + `&pageIdx=${pageNumber - 1}`
    + `&pageSize=${pageSize}`;

  if (Object.keys(appliedFilters).length) {
    Object.entries(appliedFilters).forEach(([filter, filterOption]) => {
      rebatesUrl += `&filter_${filter}=${filterOption}`;
    });
  }

  if (searchedItem) {
    rebatesUrl += `&q=${searchedItem}`;
  }

  return rebatesUrl;
};
